module.exports = __webpack_public_path__ + "img/bg-img-white2.1c77d0cc.png";